export function normalizePtBrText(value: string | null | undefined): string {
  if (!value) {
    return '';
  }

  return value
    .normalize('NFD')
    .replace(/\p{M}/gu, '')
    .toLowerCase();
}

export function includesPtBrSearch(
  haystack: string | null | undefined,
  needle: string | null | undefined,
): boolean {
  const normalizedNeedle = normalizePtBrText(needle).trim();

  if (!normalizedNeedle) {
    return true;
  }

  return normalizePtBrText(haystack).includes(normalizedNeedle);
}
